<template>
  <shell>
    
    <div class="lg:w-full container m-auto">
      <div class="w-full lg:w-1/2 m-auto relative px-2">
        <h2 class="text-2xl pb-4">Create Spell</h2>


        <div v-if="['EMAIL', 'DONE_EMAIL', 'TODO_EMAIL', 'REMINDER_EMAIL'].indexOf(spellKind) !== -1">

          <div v-if="member.email_verified === false" class="px-4 py-2 mb-6 bg-red">
            <div class="bg-red text-white text-sm leading-normal">
              Please add an email on the <router-link class="text-white" to="/account">account page</router-link>. Once you verify your email you can create an email Spell. 
            </div>
          </div>
        </div>


        <div v-else-if="['SMS'].indexOf(spellKind) !== -1">

          <div v-if="member.phone_number_verified === false" class="px-4 py-2 mb-6 bg-red">
            <div class="bg-red text-white text-sm leading-normal">
              Please add your phone number on the <router-link class="text-white" to="/account">account page</router-link>. Once you verify your phone number you can create an the text reminder spell.
            </div>
          </div>
        </div>

        <div v-if="error" class="px-4 py-2 mb-4 bg-red-lightest">
          <t-text kind="DANGER">{{error}}</t-text>
        </div>


        <div class="pb-10">
          <div class="bg-black py-4 px-2 rounded">
            <query-name
              :key="spellKind"
              :fn="pig.fn"
              :frequency="pig.mode"
              :startDate="pig.start_from"
            />
          </div>
        </div>
        <div class="block">
          <edit-spell
            :key="spellKind"
            v-model="pig"
            :defaultTags="tags"
            :defaultPath="path"
            :defaultSpellKind="spellKind"
          />

          <div class="flex justify-end items-center">
            <router-link class="ml-4 text-black no-underline" to="/spells">Cancel</router-link>
            <t-button class="ml-4" @click="handler">Make Spell</t-button>
          </div>
        </div>
      </div>
    </div>
  </shell>
</template>

<script>
 import { DateTime } from 'luxon';
 import {mapState} from 'vuex';
 import api from '@/api';
 import Shell from '@/components/Shell';
 import QueryName from '@/components/QueryName';
 import EditSpell from '@/components/EditSpell';


 const defaultSpell = (kind, tags, path, todoSelect) => {
   if (['EMAIL', 'TODO_EMAIL', 'DONE_EMAIL'].indexOf(kind) !== -1) {
     return {
       tmpl: 'standard',
       query: {
         records: {
           AND: []
         },
         interval: 'WEEK'
       }
     };
   } else if (kind === 'TODO_EMAIL') {

     return {
       tmpl: 'standard',
       query: {
         records: {
           AND: [
             {
               entity: 'TODO',
               term: 'TODO'
             }
           ]
         },
         interval: 'WEEK'
       }
     };
   } else if (kind === 'DONE_EMAIL') {
     return {
       tmpl: 'standard',
       query: {
         records: {
           AND: [
             {
               entity: 'TODO',
               term: 'DONE'
             }
           ]
         },
         interval: 'WEEK'
       }
     };
   } else if (kind === 'SMS') {
     return {
       text: 'What did you do today?',
       save: false
     };
   } else if (kind === 'NOTE') {
     return {
       text: ''
     };
   } else if (kind === 'REMINDER_EMAIL') {
     return {
       subject: '',
       text: '',
     };
   } else {
     return {}
   }
 }

 export default {
   props: {
     spellKind: {
       type: String,
       required: true
     },
     path: {
       type: String,
       default: '/'
     },

     tags: {
       type: Array,
       default: () => ([])
     },

   },

   components: {Shell, EditSpell, QueryName},

   data () {
     return {
       error: '',
       pig: {
         mode: 'WEEKLY',
         start_from: DateTime.local().toISO(),
         fn: {
           run: {
             [this.spellKind]: defaultSpell(this.spellKind)
           }
         }
       }
     }
   },

   computed: {
     ...mapState({
       member: state => state.member,
     })
   },

   methods: {
     async handler () {
       const {err} = await api.createPig(this.pig);

       if (err) {
         this.error = err.response.data;
         return
       }
       this.$router.push({name: 'spells'});
     }
   },

   watch: {
     $route (to) {
       if (to !== 'logout') {
         this.pig = {
           mode: 'WEEKLY',
           __bust__: to.name, // NOTE cache busting?
           start_from: DateTime.local().toISO(),
           fn: {
             run: {
               [this.spellKind]: defaultSpell(this.spellKind)
             }
           }
         }
       }
     }
   }
 }
</script>
